export default __webpack_public_path__ + "7cc1738722f3645db046d2f9b0122d76.svg";